import React, { useRef } from "react";

import { Formik, Form } from "formik";
import { MenuVertical, Question, Error, Success } from "icons";

import { Button, Typography, Tooltip } from "clearsense-ui/components";
import { Input } from "clearsense-ui/components/formik";

import {
  RDD_VALIDATION_SCHEMA,
  RDD_INITIAL_VALUES,
  PATIENT_FORM_FIELD_DETAILS,
  RDD_INITIAL_VALUES_LOW_RISK,
  RDD_INITIAL_VALUES_HIGH_RISK,
} from "./constants";

const PatientDetailsForm = ({ patientData, handleSubmit, setPrediction }) => {
  const formikRef = useRef();

  const handleFormPrefill = prefillValues => {
    const keys = Object.keys(prefillValues);
    keys.map(key => formikRef.current.setFieldValue(key, prefillValues[key]));
  };

  // useEffect(() => {
  //   calculateAge();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [patientData.dateOfBirth]);

  // const calculateAge = () => {
  //   const diff = dayjs().diff(
  //     dayjs(patientData.dateOfBirth, "DD-MM-YYYY"),
  //     "year"
  //   );
  //   const age = isNaN(diff) ? "" : diff;
  //   setFormValues(formValues => ({
  //     ...formValues,
  //     b: age,
  //   }));
  // };

  return (
    <>
      <Typography style="h3" type="semibold" className="text-gray-600">
        Prefill with sample values
      </Typography>
      <div className="flex gap-4 justify-start items-center -mt-4">
        <Button
          style="secondary"
          label="Populate form with low risk values"
          onClick={() => handleFormPrefill(RDD_INITIAL_VALUES_LOW_RISK)}
          iconPosition="right"
          icon={() => <Success size={20} className="ml-2" />}
        />
        <Button
          style="secondary"
          label="Populate form with high risk values"
          onClick={() => handleFormPrefill(RDD_INITIAL_VALUES_HIGH_RISK)}
          iconPosition="right"
          icon={() => <Error size={20} className="ml-2" />}
        />
      </div>
      <Formik
        enableReinitialize
        initialValues={RDD_INITIAL_VALUES}
        validationSchema={RDD_VALIDATION_SCHEMA}
        validateOnBlur
        onSubmit={handleSubmit}
        innerRef={formikRef}
        onReset={() => setPrediction()}
      >
        {({ errors, touched }) => (
          <Form>
            <Typography
              style="h3"
              type="semibold"
              className="mb-5 text-gray-600"
            >
              Add Details
            </Typography>
            {PATIENT_FORM_FIELD_DETAILS.map(field => (
              <div key={field.id} className="cs-rdd-details-wrapper">
                <Typography style="large" className="text-gray-600 w-96">
                  {field.label}
                </Typography>
                <MenuVertical />
                <Input
                  type="number"
                  name={field.name}
                  placeholder="Enter Number"
                  disabled={!!patientData.dateOfBirth && field.name === "age"}
                  className="cs-rdd-details-wrapper__input"
                  required
                />
                <Tooltip
                  theme={errors[field.name] && touched[field.name] && "error"}
                  content={field.tooltipContent}
                  position="right"
                  className="cs-rdd-details-wrapper__tooltip"
                >
                  <span>
                    <Question size={24} />
                  </span>
                </Tooltip>
              </div>
            ))}
            <div className="flex justify-center gap-5">
              <Button type="submit" label="Predict" />
              <Button label="Reset" style="secondary" type="reset" />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PatientDetailsForm;
